import type { LibrarySection } from '@/types';

interface PinOnboardingSectionsParams {
  sections: LibrarySection[];
  categories: string[];
}

/**
 * Moves the categories liked during onboarding to the front, keeping CMS order
 * within both groups. Composed under `pinDeeplinkSections` so an explicit
 * deeplink still outranks a stored preference.
 */
const pinOnboardingSections = ({
  sections,
  categories,
}: PinOnboardingSectionsParams): LibrarySection[] => {
  if (!categories.length) return sections;

  const liked = new Set(categories);
  const pinned = sections.filter(({ slug }) => liked.has(slug));

  if (!pinned.length) return sections;

  return [...pinned, ...sections.filter(({ slug }) => !liked.has(slug))];
};

export default pinOnboardingSections;
